import type { WidgetEffectParams } from '@swf/core/store';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorCode from '@swf/sports/utils/getErrorCode';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { FeaturedSuccessResponse } from '../types';

import type { WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(_payload: undefined, params: WidgetEffectParams<BasicSportsWidgetConfig>) {
    const { dispatch, widget, select, rootState } = params;

    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    const widgetSelect: WidgetSelect = select[widget.uid];

    const { featuredMenuRequested, clear }: WidgetDispatch = widgetDispatch;

    if (!widgetSelect.hasPreloaded(rootState)) {
      await featuredMenuRequested();
    }

    widget.unmount.subscribe(clear);
  },
  async featuredMenuRequested(
    _payload: undefined,
    params: WidgetEffectParams<BasicSportsWidgetConfig>
  ): Promise<void> {
    const { dispatch, request, widget, rootState } = params;
    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    const sportsRequest = buildSportsRequest(request, rootState);

    try {
      const {
        body: { data }
      } = await sportsRequest<FeaturedSuccessResponse>({
        path: '/links/featured',
        signal: getWidgetCancellationSignal(params)
      });

      widgetDispatch.dataLoadSuccess(data);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      widgetDispatch.dataLoadFailed(getErrorCode(error));
    }
  }
};
